/* Cart extras for the drawer and the cart page: a Buy 3 meter above the checkout button and a short reassurance line
   under it. The theme re-renders the cart after every change, so the extras are re-inserted whenever they go missing. */
const T = 3, P = 10;
let count = null, last = null, timer = 0;

const meterHtml = () => {
  const left = Math.max(0, T - count), done = left === 0;
  const head = done ? `${P}% off unlocked` : count === 0 ? `Buy ${T}, get ${P}% off` : `Add ${left} more, get ${P}% off`;
  const sub = done ? 'Applied automatically at checkout' : `${Math.min(count, T)} of ${T} in your cart`;
  const notches = Array.from({ length: T }, (_, i) => `<i${i < count ? ' class="is-on"' : ''}></i>`).join('');
  return `<span class="nx-cart-meter__coin" aria-hidden="true">${P}%</span><div><b>${head}</b><small>${sub}</small><span class="nx-cart-meter__bar" aria-hidden="true">${notches}</span></div>`;
};

const paint = () => {
  if (count === null) return;
  document.querySelectorAll('.cart__ctas').forEach((ctas) => {
    let m = ctas.previousElementSibling;
    if (!m || !m.classList.contains('nx-cart-meter')) {
      m = document.createElement('div');
      m.className = 'nx-cart-meter';
      m.setAttribute('role', 'status');
      ctas.before(m);
    }
    m.innerHTML = meterHtml();
    m.classList.toggle('is-done', count >= T);
    if (last !== null && count > last) { m.classList.remove('is-up'); void m.offsetWidth; m.classList.add('is-up'); }
    if (!ctas.nextElementSibling || !ctas.nextElementSibling.classList.contains('nx-cart-trust')) {
      ctas.insertAdjacentHTML('afterend', '<p class="nx-cart-trust"><span>30-day money-back guarantee</span><span>Secure checkout</span></p>');
    }
  });
  last = count;
};

const refresh = () => {
  clearTimeout(timer);
  timer = setTimeout(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { count = c.item_count; paint(); }).catch(() => {}), 120);
};

// The theme swaps cart markup in after updates; put the extras back and recount when that happens.
new MutationObserver((list) => {
  if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('.cart__ctas, cart-items-component, .cart-drawer__inner') || n.querySelector?.('.cart__ctas'))))) refresh();
}).observe(document.body, { childList: true, subtree: true });

import('@shopify/events').then((ev) => {
  document.addEventListener(ev.StandardEvents.cartLinesUpdate, (e) => { if (e.promise) e.promise.then(refresh, refresh); else refresh(); });
}).catch(() => {});
refresh();

// The motion switch lives at the bottom of the page, in the footer's last row (it stays floating on pages without that footer).
const mswitch = document.querySelector('.nx-mswitch'), base = document.querySelector('.nx-footer__base');
if (mswitch && base) base.appendChild(mswitch);
